export default __webpack_public_path__ + "static/media/fightclub_icon.1c7f983b.jpg";